































import n from '@/utils/notifications'
import t from '@/utils/tools'
import m from '@/graphql/mutation'

export default {
    name: 'vpe_table_dialog'

    props:
        toggle_dialog:
            required: true
        date:
            required: true
        vpc_set:
            required: true
        vp_custom_vp_dated_set:
            required: true
        vpc_dated_uid_set:
            required: true

    watch:
        toggle_dialog: (new_one, old_one)->
            # console.log "OPEN", new_one, old_one
            if new_one != old_one and !@dialog_visible
                @local_vpc_set = t.deep_copy(@vpc_set)
                @dialog_visible = true

        # vpc_set: (new_one, old_one)->
        #     if new_one != old_one
        #         @local_vpc_set = t.deep_copy(new_one)
        #         @manage_vpc_set_table_key = +new Date()

        # vpc_dated_uid_set: (new_one, old_one)->
        #     if new_one != old_one
        #         console.log "NEW VPC_DATED_UID_SET"

    data: ()->
        dialog_visible: false
        new_vpc: {
            uid: ''
            name: ''
            editable_by_all: false
        }
        no_change: true
        refresh_wanted: false
        manage_vpc_set_table_key: ''
        local_vpc_set: []

    methods:
        date_formatter: t.date_formatter
        has_access_right: t.has_access_right

        link_class: (uid)->
            ret = "fa-close danger"
            if uid in @vpc_dated_uid_set
                ret = "fa-check success"
            return ret

        link_title: (uid)->
            ret = "Afficher pour le mois sélectionné"
            if uid in @vpc_dated_uid_set
                ret = "Supprimer pour le mois sélectionné"
            return ret

        change_vpc_set: ()->
            @no_change = false
            return

        reset_new_vpc: ()->
            # console.log "RESET NEW VPC"
            @new_vpc = {
                uid: ''
                name: ''
                editable_by_all: false
            }
            return

        toggle_vpc_dated: (vpc)->
            # console.log "TOGGLE VPC DATED", vpc, @vpc_dated_uid_set.length
            if vpc.uid in @vpc_dated_uid_set
                # console.log "TOGGLE DELETE VPC DATED", vpc
                for vpc_vpd in @vp_custom_vp_dated_set
                    # console.log "TOGGLE DELETE LOOP", vpc_vpd.uid
                    if vpc_vpd.vp_custom.uid == vpc.uid
                        @refresh_wanted = true
                        @$emit('delete-vpc-vpd', vpc_vpd, false)
                        # console.log "TOGGLE DELETE", @vpc_dated_uid_set.length
                        return
            else
                # console.log "TOGGLE ADD VPC DATED"
                @refresh_wanted = true
                @save_vp_custom_vp_dated(vpc.uid)
            # console.log "TOGGLE VPC DATED END", @refresh_wanted
            return

        cancel_manage_vpc_set: ()->
            # console.log "CANCEL MANAGE VPC SET BEGIN", @refresh_wanted
            @dialog_visible = false
            @reset_new_vpc()
            @no_change = true
            if @refresh_wanted
                @$emit('refresh', true)
                @refresh_wanted = false
            # console.log "CANCEL MANAGE VPC SET END"
            return

        pre_cancel: ()->
            if !@no_change
                self = @
                @$confirm("Des changements sont non enregistrés, êtes-vous sûr·e de vouloir fermer la fenêtre sans enregistrer ?", 'Confirmation', {
                    confirmButtonText: 'Oui',
                    cancelButtonText: 'Annuler'
                    })
                    .then ()->
                        self.cancel_manage_vpc_set()
                    .catch (cancel)->
                        return
            else
                @cancel_manage_vpc_set()
            return

        delete_vpc: (vpc_uid)->
            # console.log "DELETE VPC", vpc_uid
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer cette colonne définitivement ainsi que toutes les valeurs déjà enregistrées qui lui sont reliées ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    m.run('delete_object', ['variable_payroll_custom', vpc_uid])
                    .then (resp)->
                        # console.log "DELETE VPC", resp.body.data.variable_payroll_custom_deletion
                        if resp.body.data.variable_payroll_custom_deletion.ok
                            if vpc_uid in self.vpc_dated_uid_set
                                self.refresh_wanted = true
                            self.local_vpc_set = self.local_vpc_set.filter (x)-> x.uid != vpc_uid
                        else
                            n.gql_error("vpe_table: delete_vpc: then", resp.body.data.variable_payroll_custom_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "vpe_table: delete_vpc()")
                .catch (cancel)->
                    return

        save_vp_custom_vp_dated: (vpc_uid)->
            # console.log "SAVE VPC_VPD", vpc_uid, @date
            self = @
            m.run('save_vp_custom_vp_dated', [vpc_uid, @date])
            .then (resp)->
                if resp.body.data.vp_custom_vp_dated_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.vp_custom_vp_dated_form_mutation.errors.length > 0
                    n.error("vpe_table: save_vp_custom_vp_dated()", JSON.stringify(resp.body.data.vp_custom_vp_dated_form_mutation.errors))
                else
                    self.vpc_dated_uid_set.push(vpc_uid)
            .catch (resp)->
                n.catch_error(resp, "vpe_table: save_vp_custom_vp_dated()")
            return

        save_vpc: ()->
            # console.log "SAVE VPC", @new_vpc, @date
            if @new_vpc.name == ''
                n.error('Erreur', 'Un nom est requis')
                return
            if @new_vpc.name.toLowerCase() in @local_vpc_set.map (x)-> return x.name.toLowerCase()
                n.error('Erreur', 'Ce nom existe déjà')
                return
            self = @
            m.run('save_variable_payroll_custom', [@$store.getters.current_company.uid, @date, @new_vpc])
            .then (resp)->
                if resp.body.data.variable_payroll_custom_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.variable_payroll_custom_form_mutation.errors.length > 0
                    n.error("vpe_table: save_vpc()", JSON.stringify(resp.body.data.variable_payroll_custom_form_mutation.errors))
                else
                    n.success()
                    form_ret = resp.body.data.variable_payroll_custom_form_mutation.form_ret.split("'")
                    self.new_vpc.uid = form_ret[1]
                    self.vpc_dated_uid_set.push(form_ret[1])
                    self.vp_custom_vp_dated_set.push({"uid":form_ret[3], "vp_custom":{"uid":form_ret[1]}})
                    self.local_vpc_set.push(self.new_vpc)
                    self.refresh_wanted = true
                    self.reset_new_vpc()
            .catch (resp)->
                n.catch_error(resp, "vpe_table: save_vpc()")
            return

        save_vpc_set: ()->
            # console.log "SAVE_VPC_SET", @local_vpc_set
            for index, item of @local_vpc_set
                if item.name == ""
                    n.error('Erreur', 'Un nom est requis')
                    return
                duplicates = @local_vpc_set.filter (x)-> return x.name == item.name
                if duplicates.length > 1
                    n.error('Erreur', 'Les colonnes doivent avoir un nom unique')
                    return

            self = @
            m.run('save_vpc_set', [@local_vpc_set])
            .then (resp)->
                # console.log "VPC SET MUTATION RESPONSE", resp.body.data.variable_payroll_custom_set_mutation.ok
                if resp.body.data.variable_payroll_custom_set_mutation.ok
                    n.success()
                    self.$emit('refresh', true)
                    self.no_change = true
                    self.refresh_wanted = false
                    self.dialog_visible = false
                    self.reset_new_vpc()
                else
                    n.error("vpe_table: save_vpc_set()", resp.body.data.variable_payroll_custom_set_mutation.message)
            .catch (resp)->
                n.catch_error(resp, "vpe_table: save_vpc_set()")
            return
            
    # beforeMount: ()->
    #     console.log "beforeMount vpe_table_dialog"
}
